export default "__VITE_ASSET__6r1Yhnya__"